var React = require('react');

function Section2MobileBottomRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.451 18.8599C33.7375 27.3933 28.6734 36.1645 20.1401 38.451C11.6067 40.7375 2.83552 35.6734 0.549022 27.1401C-1.73748 18.6067 3.32658 9.83552 11.8599 7.54902C20.3933 5.26252 29.1645 10.3266 31.451 18.8599Z","fill":"#E7F5FF","key":0}),React.createElement("rect",{"x":"20","width":"22","height":"23","fill":"#1765AB","key":1})]);
}

Section2MobileBottomRightInline.defaultProps = {"width":"42","height":"39","viewBox":"0 0 42 39","fill":"none"};

module.exports = Section2MobileBottomRightInline;

Section2MobileBottomRightInline.default = Section2MobileBottomRightInline;
